<template>
  <div class="lang">
    <myhead></myhead>
    <div class="mytit">{{ $t('a58') }}</div>
    <div class="sel">
      <div
        :class="{line:true,active:item.ishow}"
        v-for="(item,index) in lang"
        @click="selLang(index)"
        :key="index"
      >{{ item.la }}</div>
    </div>
    <div class="confirm" @click="conFim()">{{ $t('a63') }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lang: [
        {
          la: this.$t("a59"),
          idf: "en-US",
          ishow: true
        },
        // {
        //   la: this.$t("a60"),
        //   idf: "zh-CN",
        //   ishow: false
        // },
        // {
        //   la: this.$t("a61"),
        //   idf: "pt-PT",
        //   ishow: false
        // },
        // {
        //   la: this.$t("a62"),
        //   idf: "it-IT",
        //   ishow: false
        // }
      ]
    };
  },
  methods: {
    selLang(id) {
      this.lang.forEach(a => {
        this.$set(a, "ishow", false);
      });
      this.$set(this.lang[id], "ishow", true);
    },
    conFim() {
      this.lang.forEach((a, i) => {
        if (a.ishow) {
          console.log(a.idf);
          this.$log.setLocalStorage("language", a.idf);
          this.$router.go(-1);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.lang {
  padding-top: 44px;
  width: 100%;
  height: 100%;
  .sel {
    padding: 20px;
    .line {
      color: #141a22;
      font-size: 13px;
      padding: 15px 0;
      border-bottom: 1px solid #e2e6eb;
      position: relative;
      &.active::after {
        content: "";
        position: absolute;
        top: 18px;
        right: 5px;
        width: 13px;
        height: 10px;
        background: url("../../assets/img/gou.png") no-repeat;
        background-size: 100%;
      }
    }
  }
  .confirm {
    position: fixed;
    bottom: 40px;
    width: 80%;
    left: 10%;
    padding: 15px 0;
    text-align: center;
    background: #159F42;
    border-radius: 2px;
    color: #fff;
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Language/lang.vue